import React from 'react';
import { Grid } from '@mui/material';

import {
  NotificationSettingsItem,
  useDeleteUserNotificationsChannelMutation,
  useDeleteUserNotificationsPreferenceMutation,
  useUpdateUserNotificationsChannelMutation,
  useUpdateUserNotificationsPreferenceMutation,
} from 'store/apis/notifications';
import { useAppSelector } from 'store/store.hook';
import { selectCurrentUserInfo } from 'store/slices/auth.slice';
import { SectionTitle } from './section-title';
import { Option } from './option';

export interface OptionsGroupProps {
  title: string;
  options: NotificationSettingsItem[];
}

export const OptionsGroup = ({ title, options }: OptionsGroupProps) => {
  const { orgSlug, id: userId } = useAppSelector(selectCurrentUserInfo);
  const [enableNotifications] = useUpdateUserNotificationsPreferenceMutation();
  const [disableNotifications] = useDeleteUserNotificationsPreferenceMutation();
  const [enableNotificationChannel] = useUpdateUserNotificationsChannelMutation();
  const [disableNotificationChannel] = useDeleteUserNotificationsChannelMutation();

  return options.length > 0 ? (
    <>
      <SectionTitle title={title} />

      <Grid container spacing={3}>
        {options.map(({ id: preference, label, help, enabled, email, sms }, index) => (
          <Grid item xs={12} key={`operational-notification-${index}-settings`}>
            <Option
              title={label}
              subtitle={help}
              checked={enabled}
              email={email}
              sms={sms}
              onOption={() => {
                const mutate = enabled ? disableNotifications : enableNotifications;

                mutate({ orgSlug, userId, preference });
              }}
              onChannel={({ channel }) => {
                const mutate =
                  (channel === 'email' && email) || (channel === 'sms' && sms)
                    ? disableNotificationChannel
                    : enableNotificationChannel;

                mutate({ orgSlug, userId, preference, channel });
              }}
            />
          </Grid>
        ))}
      </Grid>
    </>
  ) : null;
};
